<template>
<div class="scroll">
    <!-- El FINAL -->
    <v-app id="inspire" >

        <v-snackbar
            v-model="snackbar"
            :timeout="timeout"
            >
            <p class="modalCambioModo">{{text}}</p> 
        </v-snackbar>

        <v-card color="movil-toolbar grey lighten-4" flat tile>
            <v-card  class="banner-bg" style="position: inherit; z-index: 200;">
                <div class="col s12 m12" style=" padding: 0px;  margin: 0px;">
                    <img :src="src.BannerBg" style="border-radius: 0px 0px 0px 0px  !important; width: 38% !important;">
                </div>
            </v-card>
            <div id="tool-buscarmov" style="position: inherit; z-index: 200;">
                <v-toolbar >
                    <v-autocomplete id="textomov" @keyup="searchmov" :value="banksLocalsAutocompletemov.id" background-color="white" color="#0D47A1"
                        :items="banksLocalsAutocompletemov" light item-value="id" item-text="trmOfficia" class="mx-4" :loading ="cargando"
                        flat hide-details :label="placeholderAutocomplete" solo-inverted @change="SearchLocation($event)">
                        <template v-slot:item="data">
                            <template v-if="typeof data.length == 0">
                                <v-list-item-content v-text="data.item"></v-list-item-content>
                            </template>
                            <template v-else>
                                <v-list-item-content>
                                    <v-list-item-title v-html="data.item.nombreLocal" class="titleDrawerBluetitlet"></v-list-item-title>
                                    <v-list-item-subtitle v-html="data.item.trmOfficia" class="titleDrawerBluesmallt"></v-list-item-subtitle>

                                </v-list-item-content>
                                <v-list-item-action>
                                    <small class="titleDrawergreysmallt"> {{data.item.distancia}}km</small>
                                </v-list-item-action>
                            </template>
                        </template>
                    </v-autocomplete>
                    <v-btn icon>
                        <v-img style="padding-right: 30px">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g opacity="0.5">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.9649 14.2549H15.7549L20.7449 19.2549L19.2549 20.7449L14.2549 15.7549V14.9649L13.9849 14.6849C12.8449 15.6649 11.3649 16.2549 9.75488 16.2549C6.16488 16.2549 3.25488 13.3449 3.25488 9.75488C3.25488 6.16488 6.16488 3.25488 9.75488 3.25488C13.3449 3.25488 16.2549 6.16488 16.2549 9.75488C16.2549 11.3649 15.6649 12.8449 14.6849 13.9849L14.9649 14.2549ZM5.25488 9.75488C5.25488 12.2449 7.26488 14.2549 9.75488 14.2549C12.2449 14.2549 14.2549 12.2449 14.2549 9.75488C14.2549 7.26488 12.2449 5.25488 9.75488 5.25488C7.26488 5.25488 5.25488 7.26488 5.25488 9.75488Z" fill="#012244"/>
                                </g>
                            </svg>
                        </v-img>
                    </v-btn>
                </v-toolbar>
            </div>
        </v-card>

        <v-navigation-drawer v-model="drawer" bottom absolute id="detalle" v-if="!isDesktop()"
            style="position: fixed; top: 86px !important; padding-bottom:200px !important;z-index: 205; border-radius: 20px;" :touchless="true">
            
            <v-row justify="space-around">         
                <v-icon left @click="drawer=!drawer" size="200%" style="color: #AC2E79;"> mdi-chevron-down</v-icon>
            </v-row>
            
            <v-list three-line style="padding-left: 20px;">
                <v-list-item-group v-model="detailbank" multiple active-class="deep-purple--text text--accent-4" @change="DetailInfo">
                    <v-list-item two-line disabled>
                        <v-list-item-title class="tituloMobile" style="font-weight: 900;white-space: inherit !important;" v-text="detailbank.nombreLocal">
                        </v-list-item-title>
                    </v-list-item>

                    <v-list-item two-line disabled style="padding-bottom:6px; left:-5px;">
                        <v-list-item-content>
                            <v-list-item-title class="enfasisMobile">Dirección</v-list-item-title>
                            <v-divider></v-divider>
                            <v-list-item-subtitle class="normalMobile" v-html="detailbank.direccion"></v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                    <v-divider></v-divider>

                    <v-list-item two-line disabled style="left:-5px;">
                        <v-list-item-content>
                            <v-list-item-title class="enfasisMobile" style="font-weight: 900;">Punto de Atención</v-list-item-title>
                            <v-list-item-subtitle class="normalMobile" v-html="detailbank.tipo"></v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                    <v-divider></v-divider>

                    <v-list-item two-line disabled style="left:-5px;">
                        <v-list-item-content>
                            <v-list-item-title class="enfasisMobile">Ciudad</v-list-item-title>
                            <v-list-item-subtitle class="normalMobile" v-html="detailbank.ciudad"></v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                    <v-divider></v-divider>

                    <v-list-item two-line disabled style="left:-5px;" v-if="horario">
                        <v-list-item-content>
                            <v-list-item-title class="enfasisMobile">Horarios</v-list-item-title>
                            <v-list-item-content two-line>
                                <v-list-item-subtitle>
                                    <pre class="normal">Lunes a viernes     {{detailbank.horarioLV}}</pre>
                                </v-list-item-subtitle>
                                <v-list-item-subtitle>
                                    <pre class="normal">Sábados                 {{detailbank.horarioS}}</pre>
                                </v-list-item-subtitle>
                                <v-list-item-subtitle>
                                    <pre class="normal">Domingos              {{detailbank.horarioD}}</pre>
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item-content>
                    </v-list-item>
                    <v-divider></v-divider>
                </v-list-item-group>
            </v-list>

            <v-list style="padding-left: 20px;">
                <v-list-item disabled>
                    <v-list-item-title class="enfasisMobile">Servicios</v-list-item-title>
                </v-list-item>
            </v-list>

            <v-list class="servicio" style="padding: 0px 0px 0px 0px !important; margin-left: 10px;padding-right: 5px !important;">
                <div v-for="item in services" :key="item.servicio">
                    <v-list-item  v-if="item.caract.length==0" style="border: 1px solid #F3F3F5;">
                        <v-list-item-content disabled class="servicioMobile">
                            <v-list-item-title  style="padding: 0px 0px; margin-left: 9px;">
                                <ul style="font-size:16px !important;">{{item.servicio}}</ul>
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-group style="border: 1px solid #F3F3F5;"
                        v-if="item.caract.length>0"
                        sub-group
                        >
                        <template v-slot:activator>
                            <v-list-item style="padding: 0px 0px;"> 
                                <v-list-item-content disabled class="servicioMobile">
                                    <v-list-item-title  style="padding: 0px 0px; margin-left: -20px;">
                                        <ul style="font-size:16px !important;">{{item.servicio}}</ul>
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </template>

                        <v-list-item style="padding-left: 25px;" v-for="child in item.caract" :key="child.caract">
                            <v-list-item-content class="subservicioMobile">
                                <v-list-item-title class="subservicioMobile" style="padding: 4px 0px 4px 35px;white-space: inherit !important;">
                                    <v-flex style="padding-right: 25px;text-align:justify;">
                                        - {{child.caract}}
                                    </v-flex>                                    
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-group>
                </div>
            </v-list>

            <v-list>
                <v-list-item >
                    <v-list-item-content disabled class="servicio">
                        <div class="comollegar" style="text-align: right;">
                            <img id="imgcomollegar" name="imgcomollegar" @click="ComoLlegar" :src="src.comollegarC" 
                                style="padding-top: 3px; width: 120px; height: 33px;"/>
                        </div>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>

        <v-navigation-drawer v-model="drawer" absolute id="detalle" style="width: 450px !important;z-index: 9;" v-if="isDesktop()">
            <template v-slot:prepend>
                <v-list-item-content v-if="banderabannerbdb">
                    <div class="bannerbdb-contenedor">
                        <img :src="bannerdet" class="bannerbdb">
                    </div>
                </v-list-item-content>
                <v-list-item-content v-if="!banderabannerbdb">
                    <div class="bannernobdb-contenedor">
                        <img :src="bannerdet" class="bannernobdb">
                    </div>
                </v-list-item-content>
            </template>

            <div id="tool-buscardet">
                <v-toolbar mb-2>
                    <!--- busqueda de puntos-->
                    <v-autocomplete id="textodet" @keyup="searchdet" :value="banksLocalsAutocompletedet.id" background-color="white" color="#0D47A1" 
                    :items="banksLocalsAutocompletedet" light item-value="id" item-text="trmOfficia" class="mx-4" :loading ="cargando"
                    flat hide-details label="Buscar punto de atención" solo-inverted @change="SearchLocation($event)">
                        <template v-slot:item="data">
                            <template v-if="data.length == 0">
                                <v-list-item-content v-text="data.item"></v-list-item-content>
                            </template>
                            <template v-else>
                                <v-list-item-content>
                                    <v-list-item-title v-html="data.item.nombreLocal" class="titleDrawerBluetitlet"></v-list-item-title>
                                    <v-list-item-subtitle v-html="data.item.trmOfficia" class="titleDrawerBluesmallt"></v-list-item-subtitle>

                                </v-list-item-content>
                                <v-list-item-action>
                                    <small class="titleDrawergreysmallt"> {{data.item.distancia}}km</small>
                                </v-list-item-action>
                            </template>
                        </template>
                    </v-autocomplete>

                    <v-btn icon style="top: 6px;">
                        <img :src="src.buscar" />
                    </v-btn>
                    <v-spacer></v-spacer>
                    <div id="tool-diver">
                        <v-btn @click="drawer = !drawer" icon id="cerrarDet">
                            <img :src="src.cerrardet" />
                        </v-btn>
                    </div>
                </v-toolbar>

            </div>

            <v-divider></v-divider>

            <v-list three-line style="padding-left: 20px;">
                <v-list-item-group v-model="detailbank" multiple active-class="deep-purple--text text--accent-4" @change="DetailInfo">
                    <v-list-item two-line disabled>
                        <v-list-item-title class="titulo" style="font-weight: 900;" v-text="detailbank.nombreLocal">
                        </v-list-item-title>
                    </v-list-item>

                    <v-list-item two-line disabled style="padding-bottom: 6px">
                        <v-list-item-content>
                            <v-list-item-title class="tituloDireccion">Dirección</v-list-item-title>
                            <v-list-item-subtitle class="enfasis" style="font-weight: 900;" v-html="detailbank.direccion"></v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>

                    <v-divider></v-divider>

                    <v-list-item two-line @click="ComoLlegar" style="left:-6px;top:-10px;min-height: 40px !important" class="comollegar"> 
                        <template>
                            <div class="d-inline pa-2 comollegar">
                                <img id="imgcomollegar" name="imgcomollegar" @mouseover="gris(this)" @mouseout="bg(this)" :src="src.comollegarA" 
                                    style="padding-top: 4px; width: 150px; height: 30px;"/>
                            </div>
                        </template>
                    </v-list-item>

                    <v-list-item two-line disabled style="left:-5px;">
                        <v-list-item-content>
                            <v-list-item-title class="enfasis" style="font-weight: 900;">Punto de Atención</v-list-item-title>
                            <v-list-item-subtitle class="normal" v-html="detailbank.tipo"></v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item two-line disabled style="left:-5px;">
                        <v-list-item-content>
                            <v-list-item-title class="enfasis" style="font-weight: 900;">Ciudad</v-list-item-title>
                            <v-list-item-subtitle class="normal" v-html="detailbank.ciudad"></v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>

                </v-list-item-group>
            </v-list>

            <v-list style=" padding-left: 20px; ">

                <v-list-item-group v-if="horario" style="top:-10px">
                    <v-list-item class="normal" disabled>
                        <v-list-item-title style="font-size: 18px; font-weight: 900;">Horarios</v-list-item-title>
                    </v-list-item>

                    <v-list-item class="normal" disabled two-line>
                        <v-list-item-title>Lunes a viernes</v-list-item-title>
                        <v-list-item-subtitle class="normal" v-html="detailbank.horarioLV"></v-list-item-subtitle>
                    </v-list-item>

                    <v-list-item class="normal" disabled two-line>
                        <v-list-item-title>Sábados</v-list-item-title>
                        <v-list-item-title class="normal" v-html="detailbank.horarioS"></v-list-item-title>
                    </v-list-item>

                    <v-list-item class="normal" disabled two-line>
                        <v-list-item-title>Domingos</v-list-item-title>
                        <v-list-item-subtitle class="normal" v-html="detailbank.horarioD"></v-list-item-subtitle>
                    </v-list-item>
                </v-list-item-group>

            </v-list>

            <v-list style="padding-left: 20px;">
                <v-list-item disabled>
                    <v-list-item-title class="titulo" style="font-size: 18px; font-weight: 900;">Servicios</v-list-item-title>
                </v-list-item>
            </v-list>

            <v-list class="servicio" style="padding-left: 20px;">
                <div v-for="item in services" :key="item.servicio">
                    <v-list-item-content style="padding-left: 20px;" v-if="item.caract.length==0">
                        <v-list-item-content disabled class="servicio">
                            <v-list-item-title style="padding: 0 16px;">
                                <li>{{item.servicio}}</li>
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item-content>

                    <v-list-group v-if="item.caract.length>0">
                        <template v-slot:activator>
                            <v-list-item-content disabled class="servicio">
                                <v-list-item-title>
                                    <li>{{item.servicio}}</li>
                                </v-list-item-title>
                            </v-list-item-content>
                        </template>

                        <v-list-item v-for="child in item.caract" :key="child.caract">
                            <v-list-item-content class="subservicio">
                                <v-list-item-title style="padding-left: 40px;">- {{child.caract}}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-group>
                </div>
            </v-list>
        </v-navigation-drawer>

        <div class="containermap">
            <!---Seccion Mapas-->
            <vl-map :load-tiles-while-animating="true" :load-tiles-while-interacting="true" data-projection="EPSG:4326" :z-index="100000"
             @click="ubicacionUsuario($event)">
                <vl-view :zoom.sync="zoom" :center.sync="center" @update:center="updateMapa" :rotation.sync="rotation"></vl-view>


                <vl-feature v-if="banderaUbi">
                    <vl-overlay  :position="userPosition">
                        <img width="60%" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAAE9ElEQVR4nO2dbUyVZRjHf5wXcmk2EisQ2xAncPiC0ctGLBCQNtoCpc0vaKvlllaaSrLVF11rjpdQI1dbbk75lCvEtlqCGTZkq/nS1guHDarJS0uMFgebcg7QhwPNSgie5z7nvs/j9dvub1z/+zrX/+E+13Pf5zwHBEEQBEEQBEEQrJMF7Ae+A0aBSYeN0anX1gD4FNVMCfFAIxBCf5GiNULAQcCroH62iAfa0F8QXaMVzSY03iKp220csF1Fi2Rxey07M40gkGm1iC6rgcBmwG0j3il4gOetBtsxYK2NWKdRYjUwzsakAWCRjXgnEQAWWwm0Y8CkjVgnYqmWdpYgQQFigGbEAM2IAZoRAzTj0Z3AfIj3ulm3JpOy/HQezEgi5d5w59d/ZYSL/l9oaffT0u5nLDiuOdO5EzNtaEWhj9rta1mxLGHWv+vtH2b32200n+mKUmZ/Y6mWxhvgdrmo2VbMrsrcecXVN3VS3djGxETUrhNn3gdYKT5A1cZc9r1UHIGM1GK0ARWFPkvFn2b3pscoL8hQmJF6jDUg3uumZpv9K7hh5xPEe83dtDXWgHVrMklLuce2TmpyAmX55v4XGGuAyqWjLD9dmZZqjDUgJyNJmdZDvmRlWqox1oCkxLuUaS1bammrPioYa4BKJibNPbow1oDBqwF1WkPqtFRjrAEXugaVaZ3/QZ2Waow1oKXdr0zr5Fl1Wqox1oATX/jp6Ru2rfPjwO98/GW3gowig7EGBEPjVDe22dbZ2XDK6O1pYw0AaD7TRX1Tp+X4mqMdRi8/YLgBANWNbdQdOzfvuNpj53jt0OcRyEgtxp8HTFNekEHd9hJWLp99f6inb5iqA606rnxnHsjcjNfjprwgg7L8dHIyk/9xJHmha5CWdj8nz3YTDGlZ851vgOE480TM6YgBmhEDNBMTnwu6PzWTFavzeMCXQ2JKGkuSU7lj4SIW3Bnesr7+Z4Ab10b5beAnrg70cvn78/Re6uDXn82+BwCD34TvXppM7vrN5JRsIHF5miWNob4eLrYep7P5ff4YiviGnDO6oMVL7qP0hT08XFqJ2xuvRHM8OMbXnzTx6Xt7CAxfUaJ5C2LfgNXFT7Ph9XdZsDAyJ1jXr43wwZtbuHT6w0jIx64BLreHJ7fspWhTlSrJWek8cZiP6ncwHhxTKRubBrg9Xp6rPU5WXqkKuTnj/+o0h3etJzR2Q5Vk7N2IxblcbHzjaNSLD5DxaDGVe48Q59LbiWudvfiZV8kuqtA2f3ZRRdSWvZnQtgSlpGez40gHbo/e512Mh4LsfzaP/u5v7ErF1hL01Mv7tBcfwu9B5a/UaZtfmwGrHinUNfV/WJnzuLa5ZS9IM2KAZsQAzWi/EXMQsdUFCWHEAM2IAZoRAzQjBmhGDNCMGKAZOwaY+72f6DNiNdCOAZdtxDoNy7WwY0CrjVin8ZmOSX3Io4unH12s7VkIB+eQoNNHg+0q2sBLeCnSXQRd4xQG/IaAl/Aj3IPoL0i0RpDwla+9+DfjA94CviXcououkuoRmHpt9dh4XH0scQh1xXsnyrk7Ag9qfh6ljRj5GL6JJADdWC9+95SGYINVwDDzL/7wVKyggGLm12UFp2IEhbzI3A3YqilHxzOXzkg6ngjyf52RdDxRYKbOSDqeKPLvzkg6Hg1Md0bS8WhkK9LxCIIgCIIgCIIQY/wFjP3YMMXzIz0AAAAASUVORK5CYII=" :scale="0.6" :anchor="[0.5, 1]" />
                    </vl-overlay>
                </vl-feature>

                    <vl-geoloc v-if="!banderaUbi"  @update:position="IniPosition">
                            <template slot-scope="geoloc">
                            <vl-feature v-if="geoloc.position" id="position-feature">
                                <vl-geom-point :coordinates="geoloc.position"></vl-geom-point>
                                <vl-style-box>
                                    <vl-style-icon src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAAE9ElEQVR4nO2dbUyVZRjHf5wXcmk2EisQ2xAncPiC0ctGLBCQNtoCpc0vaKvlllaaSrLVF11rjpdQI1dbbk75lCvEtlqCGTZkq/nS1guHDarJS0uMFgebcg7QhwPNSgie5z7nvs/j9dvub1z/+zrX/+E+13Pf5zwHBEEQBEEQBEEQrJMF7Ae+A0aBSYeN0anX1gD4FNVMCfFAIxBCf5GiNULAQcCroH62iAfa0F8QXaMVzSY03iKp220csF1Fi2Rxey07M40gkGm1iC6rgcBmwG0j3il4gOetBtsxYK2NWKdRYjUwzsakAWCRjXgnEQAWWwm0Y8CkjVgnYqmWdpYgQQFigGbEAM2IAZoRAzTj0Z3AfIj3ulm3JpOy/HQezEgi5d5w59d/ZYSL/l9oaffT0u5nLDiuOdO5EzNtaEWhj9rta1mxLGHWv+vtH2b32200n+mKUmZ/Y6mWxhvgdrmo2VbMrsrcecXVN3VS3djGxETUrhNn3gdYKT5A1cZc9r1UHIGM1GK0ARWFPkvFn2b3pscoL8hQmJF6jDUg3uumZpv9K7hh5xPEe83dtDXWgHVrMklLuce2TmpyAmX55v4XGGuAyqWjLD9dmZZqjDUgJyNJmdZDvmRlWqox1oCkxLuUaS1bammrPioYa4BKJibNPbow1oDBqwF1WkPqtFRjrAEXugaVaZ3/QZ2Waow1oKXdr0zr5Fl1Wqox1oATX/jp6Ru2rfPjwO98/GW3gowig7EGBEPjVDe22dbZ2XDK6O1pYw0AaD7TRX1Tp+X4mqMdRi8/YLgBANWNbdQdOzfvuNpj53jt0OcRyEgtxp8HTFNekEHd9hJWLp99f6inb5iqA606rnxnHsjcjNfjprwgg7L8dHIyk/9xJHmha5CWdj8nz3YTDGlZ851vgOE480TM6YgBmhEDNBMTnwu6PzWTFavzeMCXQ2JKGkuSU7lj4SIW3Bnesr7+Z4Ab10b5beAnrg70cvn78/Re6uDXn82+BwCD34TvXppM7vrN5JRsIHF5miWNob4eLrYep7P5ff4YiviGnDO6oMVL7qP0hT08XFqJ2xuvRHM8OMbXnzTx6Xt7CAxfUaJ5C2LfgNXFT7Ph9XdZsDAyJ1jXr43wwZtbuHT6w0jIx64BLreHJ7fspWhTlSrJWek8cZiP6ncwHhxTKRubBrg9Xp6rPU5WXqkKuTnj/+o0h3etJzR2Q5Vk7N2IxblcbHzjaNSLD5DxaDGVe48Q59LbiWudvfiZV8kuqtA2f3ZRRdSWvZnQtgSlpGez40gHbo/e512Mh4LsfzaP/u5v7ErF1hL01Mv7tBcfwu9B5a/UaZtfmwGrHinUNfV/WJnzuLa5ZS9IM2KAZsQAzWi/EXMQsdUFCWHEAM2IAZoRAzQjBmhGDNCMGKAZOwaY+72f6DNiNdCOAZdtxDoNy7WwY0CrjVin8ZmOSX3Io4unH12s7VkIB+eQoNNHg+0q2sBLeCnSXQRd4xQG/IaAl/Aj3IPoL0i0RpDwla+9+DfjA94CviXcououkuoRmHpt9dh4XH0scQh1xXsnyrk7Ag9qfh6ljRj5GL6JJADdWC9+95SGYINVwDDzL/7wVKyggGLm12UFp2IEhbzI3A3YqilHxzOXzkg6ngjyf52RdDxRYKbOSDqeKPLvzkg6Hg1Md0bS8WhkK9LxCIIgCIIgCIIQY/wFjP3YMMXzIz0AAAAASUVORK5CYII=" :scale="0.6" :anchor="[0.5, 1]"></vl-style-icon>
                                </vl-style-box>
                            </vl-feature>
                        </template>
                    </vl-geoloc>

                <vl-feature v-for='(item , index) in banksLocal' :key="index">
                    <vl-overlay :position="[item.longitud , item.latitud]">
                        <img :src="item.banner" :style="{ width:item.estado}" @click="selectpoint(item)" />
                    </vl-overlay>
                </vl-feature>

                <vl-layer-tile id="osm">
                    <vl-source-osm>
                    </vl-source-osm>
                </vl-layer-tile>

            </vl-map>
            <!--- fin Seccion Mapas-->
            <div class="overlaya ">
                <div class="map-Info-area dec-tabs">
                    <v-card dense floating style="background: transparent;">
                        <!--- banner Bg -->
                        <v-card class="banner-bg">
                            <div class="col s12 m12" style=" padding: 0px;  margin: 0px;">

                                <img :src="src.BannerBg  " style=" border-radius: 8px 8px 0px 0px  !important; width: 50%">

                            </div>
                        </v-card>
                        <!--- fin banner Bg-->
                        <div id="tool-buscar">
                            <v-toolbar mb-2>
                                <!--- busqueda de puntos-->
                                <v-autocomplete id="texto" @keyup="search" :value="banksLocalsAutocomplete.id" background-color="white" color="#0D47A1" 
                                :items="banksLocalsAutocomplete" light item-value="id" item-text="trmOfficia" class="mx-4" flat hide-details label="Buscar punto de atención" 
                                solo-inverted @change="SearchLocation($event)" :loading ="cargando">
                                    <template v-slot:item="data">
                                        <template v-if="data.length == 0">
                                            <v-list-item-content v-text="data.item"></v-list-item-content>
                                        </template>
                                        <template v-else>
                                            <v-list-item-content>
                                                <v-list-item-title v-html="data.item.nombreLocal" class="titleDrawerBluetitlet"></v-list-item-title>
                                                <v-list-item-subtitle v-html="data.item.trmOfficia" class="titleDrawerBluesmallt"></v-list-item-subtitle>

                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <small class="titleDrawergreysmallt"> {{data.item.distancia}}km</small>
                                            </v-list-item-action>
                                        </template>
                                    </template>
                                </v-autocomplete>

                                <v-btn icon>
                                    <img :src="src.buscar" />
                                </v-btn>
                            </v-toolbar>
                        </div>
                        <!---fin busqueda de puntos  -->
                        <!---check servicio  -->
                        <v-container id="check-servicios" class="white" style="margin-top: 15px;" v-if="bonos">
                            <v-row mb-6 no-gutters>
                                <v-col>
                                    <v-card>
                                        <v-checkbox v-model="changecheck" label="Banco del Barrio" color="red " value="bdb" hide-details></v-checkbox>
                                    </v-card>
                                </v-col>
                                <v-col>
                                    <v-card tile>
                                        <v-checkbox v-model="changecheck" label="Agencias" color="red" value="agc" hide-details></v-checkbox>
                                    </v-card>
                                </v-col>
                            </v-row>
                            <v-row mb-6 no-gutters>
                                <v-col>
                                    <v-card>
                                        <v-checkbox v-model="changecheck" label="Cajeros" color="red" value="atm" hide-details></v-checkbox>
                                    </v-card>
                                </v-col>
                                <v-col>
                                    <v-card tile>
                                        <v-checkbox v-model="changecheck" label="Autobancos" color="red" value="atb" hide-details></v-checkbox>
                                    </v-card>
                                </v-col>
                            </v-row>
                            <v-row mb-6 no-gutters>
                                <v-col>
                                    <v-card>
                                        <v-checkbox v-model="changecheck" label="Cajeros Multifución" color="red" value="mlf" hide-details></v-checkbox>
                                    </v-card>
                                </v-col>

                            </v-row>
                        </v-container>
                        <!---fin check servicio  -->
                        <!---mi ubicacion  -->
                        <v-container id="check-servicios" class="white" style="    margin-top: 15px;">
                            <v-row mb-6 no-gutters>
                                <v-col>
                                    <v-card :disabled="!oklocation">
                                        <strong class="text-bg3" @click="PuntoCercano">Ver el punto más cercano</strong>
                                    </v-card>
                                </v-col>
                                <v-col>
                                    <v-card :disabled="!oklocation" class="text-lg-right">
                                        <a class="transparent abajomenu" @click="PuntoCercano" style="    position: inherit;   top: 25px;     ">
                                            <img :src="src.imgcerca" />
                                        </a>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-container>

                        <v-container id="check-servicios" class="white no-gutters" style="margin-top: 15px;">
                            <v-expansion-panels v-model="panel" class="white no-gutters" style="z-index: unset;">
                                <v-expansion-panel>
                                    <v-expansion-panel-header style="padding: 0px;">
                                        <strong class="text-bg3">¿Que debo hacer si mi ubicación no es correcta?</strong>
                                        <template v-slot:actions>
                                        <v-icon color="primary">
                                                $expand
                                        </v-icon>
                                        </template>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <p style="text-align: justify !important;" class="normal">
                                            Si el avatar no está ubicado en dónde te encuentras, presiona la tecla Shift para activar la ubicación manual, luego deslízate en el mapa hasta encontrar tu ubicación correcta y da un clic.
                                        </p>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                         </v-container>

                        <!---fin mi ubicacion   -->
                    </v-card>

                </div>

            </div>
            <div class="overlayacontrol">
                <v-container class="white" style="background-color: transparent !important;">
                    <v-row mb-6 no-gutters style=" height: 75px; ">
                        <v-col  id = "ubicacionUsuario" style="visibility:hidden; height: 50px;">
                            <v-card da ta-toggle="tooltip" title="Seleciona tu ubicación"  id="btnUserUbication" name="btnUserUbication" style=" border-radius:8px 8px  8px 8px !important;" @click="MensajeConfirmacion">
                                <a  style="top:-1px;" class=" transparent abajomenu v-btn v-btn--flat v-btn--icon v-btn--round theme--light v-size--default">
                                    <img src="../assets/Ico_bg/ubicacion.png" width="110%"/>
                                </a>
                            </v-card>
                        </v-col>
                        <v-col style=" height: 35px; ">
                            <v-card data-toggle="tooltip" title="Ubicación" :disabled="banderaBtnUbicacion" id="btnUbicacion" name="btnUbicacion" style=" border-radius:8px 8px  8px 8px !important;" @click="mylocation">
                                <a  style="top:-3px;" class=" transparent abajomenu v-btn v-btn--flat v-btn--icon v-btn--round theme--light v-size--default">
                                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAANNSURBVHgBxVddTttAEJ5ZG6iqVkrfKlGicIKGp5C+kJ6g3KDhAmU5AckJcLhAww3gBISXBp5IT0AKqdTHSFRVA2Snsxvb2XWcxKRIfBJi7Z2db+ffQVgA7Xeygkif9ZoIj8q9oAWPhA+LgKAACFW9FKRasAAEPBMwq+BlQeb+KpBItEUIRSTI6fe87qOCDpt+TEKclLtBN4u+ucTtgizgkL7ysgLZ0CQP6/MuMJO4vSargHQQWadBAH1B0GVLO/yYC/8q9jktQ4j1D9dB8Gjidl7W2K37lraWpyjw/4izjX7Qn5BflVUURr4QHyG2vBfUMhN/y0spiA7GpCQ3e4cNyICL/Jd9JqzFBEjV0vXh0VxiHVNQdBm5d9rBWdAhQjB5YdwOHm4kYz5Rx5xI2l0jUqJa6WaSVGf43WAUV7UCnaTS8k3QPF+VOc70A9S6HswlPjo8kLCWia/Cx+7mTWM9ZT8tw1Mz+Xxt9zSSXbnFN3ZuOA0Elfo0XlNtglTRKaSXVVXvmTBZ8IDirL57pXbtPbdzEW5Hy9JP18UmBASOYvcsFHDk0hi+J850gxltY8XRpxt+rNALa5ZLZ7PXiGOSCMFMJF16kd+9JIKiSTKFeyNW6PpmyoQNX6dguOHUqRiag5kweKm2+PRJ9MykutEUTZKJ2CPNaUOiD08EhHHXs+HreRqNNuVhELq6aAste9AaDCETSInvznNIbFqtIml4UPxwyilKfy304hbX7VjZpTEDTS7BnYROCm/g5I1bTkgt859vOXjNsbJvfo9aYRemo8sydfuFGTJjDcf2nkO8LMS4HxNKe6/8K9CK9Y2bkARbo/e0DLiGxEOGHsSJs5fUYbtUIe6ljbb2W1nwl9R7vfZvp0wrd7pNhADTlMLyEw+Jex4SCW9MlJMRoLDQwczUJjeZGmSEHqkRqbk4D5okqXk/TUFyrupuwwpradabaTXU1UC6H1ds0lLvsJ6mf+anD482SR7t258+BpxMYXfr815RCe7Tyc8jJDkrRPM/9jjmuGSSpApZoDP8AXfS3PsoYucCPo9NxG2Kei+MrGNrOxyG1vJv0UjL8P8idi4x+rAzCcRzuJocoVnwbL8kFvrt5OHwSoFo6rVu+LAA/gHKJLEIOy+84QAAAABJRU5ErkJggg==" />
                                </a>
                            </v-card>
                        </v-col>
                        <v-col id="zomin" style=" height: 35px;  margin-top: 15px;">
                            <v-card data-toggle="tooltip" title="Zoom In" style="border-radius:8px 8px  0px 0px !important;" @click="zoominevent">
                                <a class="transparent abajomenu v-btn v-btn--flat v-btn--icon v-btn--round theme--light v-size--default">
                                    <img :src="src.zoomout" />
                                </a>
                            </v-card>
                        </v-col>
                        <v-col data-toggle="tooltip" title="Zoom Out" id="zomou" style=" height: 35px;  margin-top: 6px; ">
                            <v-card style="border-radius: 0px 0px 8px 8px !important;" @click="zoomoutevent">
                                <a class="transparent abajomenu  v-btn v-btn--flat v-btn--icon v-btn--round theme--light v-size--default">
                                    <img :src="src.zoomin" />
                                </a>
                            </v-card>
                        </v-col>

                    </v-row>

                </v-container>
            </div>
        </div>
        <loading></loading>
        <loadinginfo></loadinginfo>
        <infoUbicacion></infoUbicacion>

    </v-app>

    <v-footer id='footerPrincipal' :disabled="!oklocation" v-show="ModelfooterPrimario" :absolute="true"
        style="bottom: 0px !important; 
            margin-top: 0px !important; 
            padding: 0px 0px 0px 0px !important; 
            border-radius: 20px 20px 0px 0px !important; 
            background: #F8F7F9!important;
            position: absolute;">
        <v-row class ="no-gutters" v-if="bonos">
            <v-menu  v-model="menu" top :close-on-click="closeOnClick" :close-on-content-click="false">
                <template v-slot:activator="{ on, attrs }">
                    <v-row class ="no-gutters">
                        <v-col class ="no-gutters">
                            <v-card height="38px" v-bind="attrs" v-on="on" 
                                style="background:#F8F7F9;box-shadow: none !important; text-align: center;" >
                                <svg style="vertical-align: -webkit-baseline-middle;" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11 5C12.1046 5 13 4.10457 13 3C13 1.89543 12.1046 1 11 1C9.89543 1 9 1.89543 9 3C9 4.10457 9.89543 5 11 5Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M1 3H9" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M13 3H17" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M5 11C6.10457 11 7 10.1046 7 9C7 7.89543 6.10457 7 5 7C3.89543 7 3 7.89543 3 9C3 10.1046 3.89543 11 5 11Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M1 9H3" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M7 9H17" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M14 17C15.1046 17 16 16.1046 16 15C16 13.8954 15.1046 13 14 13C12.8954 13 12 13.8954 12 15C12 16.1046 12.8954 17 14 17Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M1 15H12" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M16 15H17" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </v-card>
                        </v-col>
                        <v-col class ="no-gutters">
                            <v-card style="background:#F8F7F9;box-shadow: none !important;"> 
                                <strong class="text-bgf" @click="Abrirmenu">Filtrar puntos de atención</strong>
                            </v-card>
                        </v-col>
                        <v-col class ="no-gutters">
                            <v-card height="38px" v-bind="attrs" v-on="on" 
                                style="background:#F8F7F9;box-shadow: none !important;text-align: -webkit-right;">
                                <v-icon left @click="cerrarmenu" size="200%" 
                                    style="vertical-align: -webkit-baseline-middle;"> mdi-chevron-up</v-icon>
                            </v-card>
                        </v-col>
                    </v-row>
                </template>

                <v-row class ="no-gutters"
                    style="bottom: 25px !important; 
                        margin-top: 0px !important; 
                        padding: 0px 0px 0px 0px !important; 
                        border-radius: 20px 20px 0px 0px !important; 
                        background: #F8F7F9!important;">
                    <v-row class ="no-gutters" style="background:#F8F7F9;">
                        <v-col style="align-self: center;background: #F8F7F9 !important;" >
                            <v-card height="38px" v-bind="attrs" v-on="on" @click="cerrarmenu"
                                    style="background:#F8F7F9;box-shadow: none !important; text-align: center;" >
                                    <svg style="vertical-align: -webkit-baseline-middle;" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M11 5C12.1046 5 13 4.10457 13 3C13 1.89543 12.1046 1 11 1C9.89543 1 9 1.89543 9 3C9 4.10457 9.89543 5 11 5Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M1 3H9" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M13 3H17" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M5 11C6.10457 11 7 10.1046 7 9C7 7.89543 6.10457 7 5 7C3.89543 7 3 7.89543 3 9C3 10.1046 3.89543 11 5 11Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M1 9H3" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M7 9H17" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M14 17C15.1046 17 16 16.1046 16 15C16 13.8954 15.1046 13 14 13C12.8954 13 12 13.8954 12 15C12 16.1046 12.8954 17 14 17Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M1 15H12" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M16 15H17" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                            </v-card>
                        </v-col>
                        <v-col>
                            <v-card style="background-color:#F8F7F9;box-shadow: none !important;"> 
                                <strong class="text-bg5" @click="cerrarmenu">Filtrar puntos de atención</strong>
                            </v-card>
                        </v-col>
                        <v-col style="align-self: center;background: #F8F7F9 !important;">
                            <v-card height="38px" v-bind="attrs" v-on="on" 
                                style="background:#F8F7F9;box-shadow: none !important;text-align: -webkit-right;">
                                    <v-icon left @click="cerrarmenu" size="200%"> mdi-chevron-down</v-icon>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-row>

                <div id="menufooter" style="padding: 0px 0px 0px 0px !important; margin: 0px 0px 0px 0px !important;">
                    <v-row id="check-serviciosmovil" mb-6 no-gutters>
                        <v-col style="background: #F8F7F9 !important;">
                            <v-card style="background: #F8F7F9 !important;">
                                <v-checkbox v-model="changecheck" label="Banco del Barrio" color="red " value="bdb" hide-details></v-checkbox>
                            </v-card>
                        </v-col>
                        <v-col style="background: #F8F7F9 !important;">
                            <v-card tile style="background: #F8F7F9 !important;">
                                <v-checkbox v-model="changecheck" label="Agencias" color="red" value="agc" hide-details></v-checkbox>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row id="check-serviciosmovil" mb-6 no-gutters>
                        <v-col style="background: #F8F7F9 !important;">
                            <v-card style="background: #F8F7F9 !important;">
                                <v-checkbox v-model="changecheck" label="Cajeros" color="red" value="atm" hide-details></v-checkbox>
                            </v-card>
                        </v-col>
                        <v-col style="background: #F8F7F9 !important;">
                            <v-card tile style="background: #F8F7F9 !important;">
                                <v-checkbox v-model="changecheck" label="Autobancos" color="red" value="atb" hide-details></v-checkbox>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row id="check-serviciosmovil" mb-6 no-gutters>
                        <v-col style="background: #F8F7F9 !important;">
                            <v-card style="background: #F8F7F9 !important;">
                                <v-checkbox v-model="changecheck" label="Cajeros Multifución" color="red" value="mlf" hide-details></v-checkbox>
                            </v-card>
                        </v-col>
                    </v-row>
                </div>
            </v-menu>    
        </v-row>

        <v-row class ="no-gutters" style="padding: 0px 0px 0px 0px !important; margin: 0px 0px 0px 0px !important; background-color: #453F67 !important;">
            <v-col  style="padding: 0px 0px 0px 15px !important; margin: 0px 0px 0px 0px !important;">
                <strong class="text-bg3" style="color:white !important" @click="PuntoCercano">Buscar el punto más cercano</strong>
            </v-col>
            <v-col @click="PuntoCercano"
                style="text-align: right; padding: 16px 13px 0px 0px !important;background-color: #453F67 !important;">
                    <svg style="vertical-align: -webkit-baseline-middle;" width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12.8741 2C16.2001 2 18.9031 4.69 18.9031 8C18.9031 12.5 12.8741 19 12.8741 19C12.8741 19 6.84516 12.5 6.84516 8C6.84516 4.69 9.54816 2 12.8741 2ZM19.908 22V20H5.84033V22H19.908ZM8.85483 8C8.85483 5.79 10.6535 4 12.8741 4C15.0948 4 16.8935 5.79 16.8935 8C16.8935 10.13 14.8034 13.46 12.8741 15.91C10.9449 13.47 8.85483 10.13 8.85483 8ZM10.8645 8C10.8645 6.9 11.7688 6 12.8741 6C13.9795 6 14.8838 6.9 14.8838 8C14.8838 9.1 13.9895 10 12.8741 10C11.7688 10 10.8645 9.1 10.8645 8Z" fill="white"/>
                    </svg>
            </v-col>
        </v-row>
    </v-footer>

    <v-footer :disabled="!oklocation" id='footerSecundario' v-show="ModelfooterSecundario" :absolute="true"
        style="bottom: 0px !important; 
            margin-top: 0px !important; 
            padding: 0px 0px 0px 0px !important; 
            border-radius: 20px 20px!important; 
            position: absolute;">
        <v-row class ="no-gutters">
            <v-list width="100%" style="padding: 0px 0px 0px 0px !important;background: transparent!important;">
                <v-list-item-group v-model="detailbank" multiple active-class="deep-purple--text text--accent-2" @change="DetailInfo"
                    style="padding: 0px 0px 0px 0px !important;">
                    <v-row class ="no-gutters"
                        style="bottom: 0px !important; 
                            margin-top: 0px !important; 
                            padding: 12px 0px 0px 0px !important; 
                            border-radius: 20px 20px!important; 
                            background: white!important;
                            justify-content: center;">        
                        <v-icon left @click="cerrarmenupys" size="200%" style="color: #AC2E79;"> mdi-chevron-down</v-icon>
                    </v-row>

                    <v-list-item two-line @click="drawer=!drawer">
                        <p  class="enfasisMobile2">  {{detailbank.direccion}} </p>
                    </v-list-item>
                    <br><br>
                    <v-list-item two-line @click="drawer=!drawer">
                        <v-list-item-content>
                            <v-list-item-title class="comollegarMobile">Punto de atención</v-list-item-title>
                            <v-list-item-subtitle class="normalMobile" style="font-weight: 900;" v-html="detailbank.tipo"></v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>

                    <v-divider></v-divider>

                    <v-list-item two-line style="min-height: 40px !important;" class="comollegar"> 
                        <v-row class ="no-gutters">
                            <v-col class ="no-gutters" @click="drawer=!drawer">
                                <strong class="vermas">Ver más    </strong>
                                <svg width="12" height="13" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11.92 6.62019C11.8724 6.49743 11.801 6.38529 11.71 6.29019L6.71 1.29019C6.61676 1.19695 6.50607 1.12299 6.38425 1.07253C6.26243 1.02207 6.13186 0.996094 6 0.996094C5.7337 0.996094 5.4783 1.10188 5.29 1.29019C5.19676 1.38342 5.1228 1.49411 5.07234 1.61594C5.02188 1.73776 4.99591 1.86833 4.99591 2.00019C4.99591 2.26649 5.1017 2.52188 5.29 2.71019L8.59 6.00019H1C0.734784 6.00019 0.48043 6.10554 0.292893 6.29308C0.105357 6.48062 0 6.73497 0 7.00019C0 7.2654 0.105357 7.51976 0.292893 7.70729C0.48043 7.89483 0.734784 8.00019 1 8.00019H8.59L5.29 11.2902C5.19627 11.3831 5.12188 11.4937 5.07111 11.6156C5.02034 11.7375 4.9942 11.8682 4.9942 12.0002C4.9942 12.1322 5.02034 12.2629 5.07111 12.3848C5.12188 12.5066 5.19627 12.6172 5.29 12.7102C5.38296 12.8039 5.49356 12.8783 5.61542 12.9291C5.73728 12.9798 5.86799 13.006 6 13.006C6.13201 13.006 6.26272 12.9798 6.38458 12.9291C6.50644 12.8783 6.61704 12.8039 6.71 12.7102L11.71 7.71019C11.801 7.61508 11.8724 7.50294 11.92 7.38019C12.02 7.13672 12.02 6.86365 11.92 6.62019Z" fill="#BC157C"/>
                                </svg>
                            </v-col>
                            <v-col class ="no-gutters" style="text-align: end;" @click="ComoLlegar">
                                <img  id="imgcomollegars" name="imgcomollegar" :src="src.comollegarC" 
                                    style="padding-top: 9px; width: 120px; height: 39px;"/>
                            </v-col>
                        </v-row>
                    </v-list-item>
                </v-list-item-group>
            </v-list>
        </v-row>

        <v-row class ="no-gutters" style="padding: 0px 0px 0px 0px !important; margin: 0px 0px 0px 0px !important; background-color: #453F67 !important;">
            <v-col style="padding: 0px 0px 0px 15px !important; margin: 0px 0px 0px 0px !important;">
                <strong class="text-bg3" style="color:white !important" @click="PuntoCercano">Buscar el punto más cercano</strong>
            </v-col>
            <v-col @click="PuntoCercano"
                style="text-align: right; padding: 16px 13px 0px 0px !important;background-color: #453F67 !important;">
                    <svg style="vertical-align: -webkit-baseline-middle;" width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12.8741 2C16.2001 2 18.9031 4.69 18.9031 8C18.9031 12.5 12.8741 19 12.8741 19C12.8741 19 6.84516 12.5 6.84516 8C6.84516 4.69 9.54816 2 12.8741 2ZM19.908 22V20H5.84033V22H19.908ZM8.85483 8C8.85483 5.79 10.6535 4 12.8741 4C15.0948 4 16.8935 5.79 16.8935 8C16.8935 10.13 14.8034 13.46 12.8741 15.91C10.9449 13.47 8.85483 10.13 8.85483 8ZM10.8645 8C10.8645 6.9 11.7688 6 12.8741 6C13.9795 6 14.8838 6.9 14.8838 8C14.8838 9.1 13.9895 10 12.8741 10C11.7688 10 10.8645 9.1 10.8645 8Z" fill="white"/>
                    </svg>
            </v-col>
        </v-row>
    </v-footer>
</div>
</template>

<script>
import bannerbg from '../assets/Ico_bg/logobanner.png';
import icocercano from '../assets/Ico_bg/pin_drop_24px_outlined.svg';
import icomas from '../assets/Ico_bg/add_24px.svg';
import icomenos from '../assets/Ico_bg/remove_24px.svg';
import arriba from '../assets/Ico_bg/VectorArriba.png';
import abajo from '../assets/Ico_bg/VectorAbajo.png';
import flechaabajo from '../assets/Ico_bg/magabajo.png';
import buscarico from '../assets/Ico_bg/search.png';
import cerrarico from '../assets/Ico_bg/cerrar.png';
import bannerbdb from '../assets/BannerBancoBarrio.png';
import comollegar from '../assets/Ico_bg/directions_24px.png';
import abajoBlanco from '../assets/Ico_bg/chevron_right_25px.png';
import filtrar from '../assets/Ico_bg/filter.png';


import comollegar1 from '../assets/Ico_bg/comollegar1.png';
import comollegar2 from '../assets/Ico_bg/comollegar2.png';
import comollegar3 from '../assets/Ico_bg/CL_BG.png';

import restclient from "axios";
import loading from '../components/loading';
import loadinginfo from '../components/info';
import infoUbicacion from '../components/infoUbicacion';
import {
    mapMutations,mapGetters 
} from "vuex";
export default {
    name: 'App',

    components: {
        loading,
        loadinginfo,
        infoUbicacion,
    },

    data() {

        return {
            selectedFeatures: [],
            oklocation: false,
            menu: false,
            closeOnClick: false,
            drawType: undefined,
            mapPanel: {
                tab: 'state',
            },
            bannerdet: bannerbdb,
            banderabannerbdb:false,
            src: {
                BannerBg: bannerbg,
                imgcerca: icocercano,
                zoomin: icomenos,
                zoomout: icomas,
                abrir: arriba,
                cerrar: abajo,
                buscar: buscarico,
                cerrardet: cerrarico,
                llegar: comollegar,
                BannerBdb: bannerbdb,
                comollegarA: comollegar1,
                comollegarB: comollegar2,
                comollegarC: comollegar3,
                cerrarabajo: flechaabajo,
                arribaBlanco:abajoBlanco,
                filtra:filtrar,
            },
            zoom: 8,
            center: [-78.205769913041, -1.2317964662810112],
            rotation: 0,
            geolocPosition: undefined,

            clickCoordinate: undefined,
            overlayCoordinate: [-78.205769913041, -1.2317964662810112],
            banksLocal: [],
            banksLocals: [],
            banksLocalsAutocomplete: [],
            banksLocalsAutocompletedet: [],
            banksLocalsAutocompletemov: [],
            auxupdate: true,
            locamanual: true,
            cheksbank: [],
            distaciaVisual: 1.5,
            loading: false,
            itemssearch: [],
            searchw: null,
            searchdetw: null,
            searchmovw: null,
            select: null,
            backautocomple: ['adac', 'david'],
            drawer: false,
            MiubicacionActual: [],
            detailbank: [],
            services: [],
            horario: false,
            selectId: 0,
            celular:false,
            banderaBtnUbicacion:true,
            features: undefined,
            banderaUbi:true,
            userPosition:undefined,
            mensajeError:true,
            snackbar: false,
            timeout: 300000,
            text: "Activaste la ubicación manual. Da clic dónde te encuentras.",
            ModelfooterPrimario:true,
            ModelfooterSecundario:false,
            menuSecundario: false,
            panel:[],
            attrs:undefined,
            on:undefined,
            cargando: false,
            modelAuto: null,
            delaySearch:1000,
            caracteres:2,
            bamdera: false,
            placeholderAutocomplete: "Buscar punto de atención",
            bonos:false,
        }
    },
    watch: {
        
    },
    computed: {

        changecheck: {

            get() {
                return this.cheksbank;
            },
            async set(value) {
                this.setdialogFirst(true);
                this.cheksbank = await value;
                await this.drawIni(this.center[1], this.center[0])
                this.setdialogFirst(false);
            }
        },
        ...mapGetters(['banderaUbicacionUsuario'])

    },
    methods: {
        search() {
            if (this.cargando) return
            this.cargando = true;
            this.banksLocalsAutocomplete = [];
            let val = document.getElementById("texto").value;
            
            if(val.length > this.caracteres){
                setTimeout(()=>{
                    this.banksLocalsAutocomplete = [];
                    this.banksLocalsAutocomplete = 
                        this.banksLocals.filter(
                            x =>   this.cheksbank.includes(x.trmSupervi) 
                            && x.trmOfficia.toLowerCase().includes(val.toLowerCase())
                            );
                    this.cargando = false;
                    return
                }, this.delaySearch);
            }else{
                 this.banksLocalsAutocomplete = [];
                 this.cargando = false;
                 return
            }
        },
        searchmov() {
            if (this.cargando) return
            this.cargando = true;
            this.banksLocalsAutocompletemov = [];
            let val = document.getElementById("textomov").value;
            
            if(val.length > this.caracteres){
                setTimeout(()=>{
                    this.banksLocalsAutocompletemov = [];
                    this.banksLocalsAutocompletemov = 
                        this.banksLocals.filter(
                            x =>   this.cheksbank.includes(x.trmSupervi) 
                            && x.trmOfficia.toLowerCase().includes(val.toLowerCase())
                            );
                    this.cargando = false;
                    return
                }, this.delaySearch);
            }else{
                 this.banksLocalsAutocompletemov = [];
                 this.cargando = false;
                 return
            }
        },
        searchdet() {
            if (this.cargando) return
            this.cargando = true;
            this.banksLocalsAutocompletedet = [];
            let val = document.getElementById("textodet").value

            if(val.length > this.caracteres){
                setTimeout(()=>{
                    this.banksLocalsAutocompletedet = [];
                    this.banksLocalsAutocompletedet = 
                        this.banksLocals.filter(
                            x =>   this.cheksbank.includes(x.trmSupervi) 
                            && x.trmOfficia.toLowerCase().includes(val.toLowerCase())
                            );
                    this.cargando = false;
                    return
                }, this.delaySearch);
            }else{
                 this.banksLocalsAutocompletedet = [];
                 this.cargando = false;
                 return
            }
        },

        async ObtenerDistancias(lista){
            let listaOrdenada = [];
            lista.forEach(element => {
                if (this.MiubicacionActual.length > 0) {
                let _distM = this.getKilometros(element.latitud, element.longitud, this.MiubicacionActual[1], this.MiubicacionActual[0])
                    element.distancia = _distM;
                } else {
                    let _dist = this.getKilometros(element.latitud, element.longitud, this.center[1], this.center[0])
                    element.distancia = _dist;
                }
                listaOrdenada.push(element);
            });
            this.listaOrdenada = await listaOrdenada.sort((a, b) => Number(a.distancia) - Number(b.distancia));
            return listaOrdenada;
        },

        Abrirmenu() {
            this.menu = true;
        },
        cerrarmenu() {
            this.menu = false;
        },
        cerrarmenupys() {
            this.ModelfooterPrimario= true;
            this.menu= false;
            this.ModelfooterSecundario= false;
            this.menuSecundario= false;
        },

        AbrirmenuS() {
               this.ModelfooterPrimario= true;
              this.menu= true;
              this.ModelfooterSecundario= false;
               this.menuSecundario= false;
        },
        cerrarmenuS() {
            this.menuSecundario = false;
        },
        async getDatabanks() {
            this.banksLocalsAutocomplete = [];
            //let banksLocalsAutocompleteAux = [];
            this.setdialogFirst(true);
            let datos = await restclient.post('https://dyvenpro.azurewebsites.net/api/Redis/GetBankBONOS');
            if (this.banksLocals.length===0){
                datos.data.data.forEach(element => {
                    element.trmOfficia = element.provincia + ', ' + element.direccion;
                    element.estado = "35px"
                    element.banner = this.iconservicio(element.trmSupervi)
                        if (this.MiubicacionActual.length > 0) {
                            let _distM = this.getKilometros(element.latitud, element.longitud, this.MiubicacionActual[1], this.MiubicacionActual[0])
                            element.distancia = _distM;
                        } else {
                            let _dist = this.getKilometros(element.latitud, element.longitud, this.center[1], this.center[0])
                            element.distancia = _dist;
                        }
                    this.banksLocals.push(element)
                });
                let bancostipo = await this.banksLocals.filter(x => this.cheksbank.includes(x.trmSupervi));
                this.banksLocals = this.banksLocals.sort((a, b) => Number(a.distancia) - Number(b.distancia));
                if (!this.cheksbank.includes('bdb') || this.cheksbank.length == 1) {
                    this.distaciaVisual = 4;
                } else {
                    this.distaciaVisual = 4;
                }

                bancostipo.forEach(element => {

                    let _dist = this.getKilometros(element.latitud, element.longitud, this.center[1], this.center[0])
                    element.distancia = _dist;
                    if (_dist < this.distaciaVisual) {

                        this.banksLocal.push(element)
                    }
                })
                this.setdialogFirst(false);
            }
        },

        async drawIni(latme, logme) {
            this.banksLocalsAutocomplete = [];
            this.banksLocal = [];
            if (this.banksLocals.length === 0) {
                await this.getDatabanks();
            } else {
                if (this.cheksbank.length == 1) {
                    if (this.cheksbank.length == 1) {
                        switch (this.cheksbank[0]) {
                            case "atm":
                                this.distaciaVisual = 15;
                                break;
                            case "mlf":
                                this.distaciaVisual = 100;
                                break;
                            case "bdb":
                                this.distaciaVisual = 4;
                                break;
                            case "atb":
                                this.distaciaVisual = 10000;
                                break;
                            case "agc":
                                this.distaciaVisual = 10000;
                                break;
                            default:
                        }
                    } else {
                        this.distaciaVisual = 4;

                    }
                } else {
                    this.distaciaVisual = 4;
                }

                let bancostipo = this.banksLocals.filter(x => this.cheksbank.includes(x.trmSupervi));

                bancostipo.forEach(element => {

                        let _dist = this.getKilometros(element.latitud, element.longitud, latme, logme)
                        element.distancia = _dist;

                        if (_dist < this.distaciaVisual) {

                            this.banksLocal.push(element)
                        }
                    }

                )
            }
            this.banderaBtnUbicacion = false;
        },

        iconservicio(ico) {
            let uconbank = 'data:image/png;base64,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';
            switch (ico) {
                case "atm":
                    uconbank = 'data:image/png;base64,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'
                    break;
                case "mlf":
                    uconbank = 'data:image/png;base64,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'
                    break;
                case "bdb":
                    uconbank = 'data:image/png;base64,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'
                    break;
                case "atb":
                    uconbank = 'data:image/png;base64,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'
                    break;
                default:
                    // code block
            }
            return uconbank
        },

        zoominevent() {

            this.zoom = this.zoom + 1
            console.log("zoom: "+this.zoom) 
        },
        zoomoutevent() {

            this.zoom = this.zoom - 1
            console.log("zoom: "+this.zoom) 
        },
        /////////////////////////////////
        //Mi ubicacion mas cercano 
        /////////////////////////////////
        mylocationAllow() {
            window.location.reload();
            this.banderaBtnUbicacion = false;
            this.mensajeError = true;
        },

        mylocationAllow1() {
            this.mensajeError = true;
        },

        DetailInfo() {
            this.detailbank = this.detailbankstatic;
        },
        // revisarPosicion(){
        //     if (navigator.geolocation) {
        //     console.log('Geolocation is supported!');
        //     }
        //     else {
        //     console.log('Geolocation is not supported for this Browser/OS.');
        //     }
        //     this.mylocation();
        // },


        // mylocationBG(){
        //     console.log("ENTRE CON EVENTO TECLA")
        //     if(!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        //         this.MensajeConfirmacion();
        //     }else{
        //         this.mylocation();
        //     }
        // },

        mylocation() {
            this.banderaBtnUbicacion=true;
            this.banderaUbi = this.$store.state.banderaUbicacionUsuario;
            if (this.MiubicacionActual.length > 0) {
                this.center = this.MiubicacionActual;
                //this.zoom = 16
                this.banderaBtnUbicacion=false;
            } else {
                navigator.geolocation.getCurrentPosition(
                    pos => {
                        this.mylocationAllow(pos)
                    },
                    err => {

                        this.Msgfallo(err)

                    }
                );
            }
        },
       
        updateMapa(e) {
            this.drawIni(e[1], e[0])
        },
        ComoLlegar() {
            let latEnd = this.detailbankstatic.latitud;
            let longEnd = this.detailbankstatic.longitud;
            let dir='https://www.google.com/maps/dir/?api=1&origin=' + this.MiubicacionActual[1] + ',' + this.MiubicacionActual[0] + '&destination=' + latEnd + ',' + longEnd + '&travelmode=driving';
            window.open(dir);
        },
        querySelections(v) {
            this.loading = true
            // Simulated ajax query
            setTimeout(() => {
            this.itemssearch = this.backautocomple.filter(e => {
                return (e || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1
            })
            this.loading = false
            }, 500)
        },
        // seleccionPunto(punto){
        //     if(this.isDesktop()){
        //         this.selectpoint(punto);
        //     }else{
        //         this.MostrarDetalleDePunto(punto);
        //     }
        // },
        /////////////////////////////////
        //Punto Mas cernado
        /////////////////////////////////
        PuntoCercano() {
            let banksLocalMascercano = [];
            let bancostipo = this.banksLocals.filter(x => this.cheksbank.includes(x.trmSupervi));

            bancostipo.forEach(element => {

                let _distM = this.getKilometros(element.latitud, element.longitud, this.MiubicacionActual[1], this.MiubicacionActual[0])
                element.distancia = _distM;
                banksLocalMascercano.push(element)
            });

            let banksLocalorder = banksLocalMascercano.sort((a, b) => Number(a.distancia) - Number(b.distancia));

            let bancostipoCercano = this.banksLocals.find(x => x.id === banksLocalorder[0].id);

            //  this.banksLocal.push(bancostipo)
            this.zoom = 19
            this.center = [bancostipoCercano.longitud, bancostipoCercano.latitud]
            this.banksLocals.find(x => x.id === banksLocalorder[0].id).estado = '55px'
            this.drawIni(this.center[1], this.center[0])

            this.menu = false;
            this.menuSecundario = false;
            this.ModelfooterSecundario = false;
            this.ModelfooterPrimario = true;
        },
        async SearchLocation(_data) {
            let bancostipo = await this.banksLocals.find(x => x.id === _data);
            this.zoom = 19
            this.center = [bancostipo.longitud, bancostipo.latitud- 0.000190]
            
            if (this.selectId !== 0) {
                if (this.banksLocals.find(x => x.id === this.selectId).estado !== undefined) {
                    // console.log("ID ANTERIOR: " + this.selectId)
                    this.banksLocals.find(x => x.id === this.selectId).estado = "35px"
                }

            }

            this.selectId = _data;

            if (this.banksLocals.find(x => x.id === _data).estado !== undefined) {
                // console.log("ID NUEVO: " + this.selectId)
                this.banksLocals.find(x => x.id === _data).estado = "55px"
            }

            // this.detailbank = [];
            // this.detailbank = bancostipo;
            
            // this.ObtainServices(bancostipo.trmSupervi).then(response => {
            //     this.services = response

            //     if (this.detailbank.trmSupervi === 'bdb' || this.detailbank.trmSupervi === 'atb') {
            //         this.horario = false;
            //     } else {
            //         this.horario = true;
            //     }
                
            //     if(this.isDesktop()){
            //         this.drawer = true;
            //     }else{
            //         this.ModelfooterPrimario= false;
            //         this.menu= false;
            //         this.ModelfooterSecundario= true;
            //         this.menuSecundario= true;
            //     }
                
            //     this.detailbankstatic=this.detailbank;
            //     if (this.detailbank.trmSupervi === 'bdb') {

            //         this.bannerdet = this.src.BannerBdb;
            //         this.banderabannerbdb=true;

            //     } else {
            //         this.bannerdet = this.src.BannerBg;
            //         this.banderabannerbdb=false;
            //     }
            // });

            let input = document.getElementById("textomov")
            input.blur(); 
                
            this.menu = false;
            this.menuSecundario = false;
            this.ModelfooterSecundario = false;
            this.ModelfooterPrimario = true;
            
        },
        selectpoint(_modelo) {
            this.detailbank = [];
            
            this.detailbank = _modelo;
            // console.log("this.selectId: " + this.selectId)
            if (this.selectId !== 0) {
                if (this.banksLocals.find(x => x.id === this.selectId).estado !== undefined) {
                    // console.log("ID ANTERIOR: " + this.selectId)
                    this.banksLocals.find(x => x.id === this.selectId).estado = "35px"
                }

            }

            this.selectId = _modelo.id;

            // console.log("ID NUEVO: " + this.detailbank.id)
            this.detailbank.estado = '55px'

            this.ObtainServices(_modelo.trmSupervi).then(response => {
                this.services = response

                if (this.detailbank.trmSupervi === 'bdb' || this.detailbank.trmSupervi === 'atb') {
                    this.horario = false;
                } else {
                    this.horario = true;
                }
                
                if(this.isDesktop()){
                    this.drawer = true;
                }else{
                    this.menu= false;
                    this.ModelfooterPrimario= false;
                    this.menu= true;
                    this.ModelfooterSecundario= true;
                    this.menuSecundario= true;
                    this.menu= false;
                }
                
                this.zoom = 19;
                this.center = [this.detailbank.longitud, this.detailbank.latitud - 0.000190]
                

                this.detailbankstatic=this.detailbank;
                if (this.detailbank.trmSupervi === 'bdb') {

                    this.bannerdet = this.src.BannerBdb;
                    this.banderabannerbdb=true;

                } else {
                    this.bannerdet = this.src.BannerBg;
                    this.banderabannerbdb=false;
                }
            });

          

        },
        onUpdatePosition() {
        },
        async ObtainServices(tipo) {
            let url = 'https://dyvenpro.azurewebsites.net/api/Redis/GetServiceType?type=' + tipo
            let servicesList = [];
            this.setdialogFirst(true);
            let datos = await restclient.post(url);
            servicesList = datos.data.data //datos.data.data.filter(x=>x.provincia==='IMBABURA')
            this.setdialogFirst(false);
            return servicesList
        },

         async ubicacionUsuario(evento){
             if(this.$store.state.banderaUbicacionUsuario){
                if (evento.coordinate.length > 0) {
                    this.MiubicacionActual = evento.coordinate;
                    //this.center = evento.coordinate;
                    this.geolocPosition = evento.coordinate;

                    this.snackbar = false;
                    var ajusteLat
                    var ajusteLon
                    var repeticiones

                    ajusteLat = 0.000070;
                    ajusteLon = 0.000035;
                    repeticiones = 20 - this.zoom

                    if(this.zoom >7){
                        for (let index = 0; index < repeticiones; index++) {
                            ajusteLat = ajusteLat * 2;
                            ajusteLon = ajusteLon * 2;
                        }
                    }else{
                        ajusteLat = 0;
                        ajusteLon = 0;
                    }

                    evento.coordinate[1] = evento.coordinate[1] + ajusteLat//Alto
                    evento.coordinate[0] = evento.coordinate[0] - ajusteLon//Ancho

                    this.panel = [];
                    this.userPosition = evento.coordinate;
                    this.banderaBtnUbicacion=false;
                    this.banderaUbi=false;
                    this.snackbar = true;
                    this.timeout = 2000;
                    this.text = 'Ubicación Actualizada';
                } else {
                    navigator.geolocation.getCurrentPosition(
                        pos => {
                            this.mylocationAllow(pos)
                        },
                        err => {
                            this.Msgfallo(err)
                        }
                    );
                }
                this.banksLocals = await this.ObtenerDistancias(this.banksLocals);

                this.banderaUbi=this.$store.state.banderaUbicacionUsuario;
                this.setbanderaUbicacionUsuario(false);
             }         
        },

        IniPosition(coordinate) {
            this.MiubicacionActual = coordinate;

            if (this.auxupdate) {
                this.oklocationQ();
                this.locamanual = true;
                this.center = coordinate
                this.zoom = 14
                this.auxupdate = false;
                this.drawIni(this.center[1], this.center[0])
            }
        },
        ///metodos de calculo
        rad(x) {
            return x * Math.PI / 180;
        },
        getKilometros(lat1, lon1, lat2, lon2) {

            var R = 6378.137; //Radio de la tierra en km
            var dLat = this.rad(lat2 - lat1);
            var dLong = this.rad(lon2 - lon1);
            var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(this.rad(lat1)) * Math.cos(this.rad(lat2)) * Math.sin(dLong / 2) * Math.sin(dLong / 2);
            var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            var d = R * c;
            return d.toFixed(3); //Retorna tres decimales
        },
        oklocationQ() {

            this.oklocation = true;
        },
        Msgfallo(error) {
            this.mensajeError = false;
            switch (error.code) {
                case error.PERMISSION_DENIED:
                    this.setdialoginfo(true);
                    break;
                case error.POSITION_UNAVAILABLE:
                    this.setdialoginfo(true);
                    break;
                case error.TIMEOUT:
                    this.setdialoginfo(true);
                    break;
                case error.UNKNOWN_ERROR:
                    this.setdialoginfo(true);
                    break;
            }
            this.banderaBtnUbicacion = false;
        },
        isDesktop()
        {
            var bandera = false;
            if(!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                bandera = true;
            }
            return bandera;
        },
        gris(){
            if(this.isDesktop()) {
                document.getElementById("imgcomollegar").src=this.src.comollegarB;
            }
        },

        bg(){
            document.getElementById("imgcomollegar").src=this.src.comollegarA;
        },

        MensajeConfirmacion(){
            if(this.isDesktop()) {
                document.getElementById("imgcomollegar").src=this.src.comollegarB;
            }
            if(this.mensajeError){
                //this.setdialogubicacion(true);
                if(this.isDesktop()){
                    this.snackbar = true;
                    this.timeout = 300000;
                    this.text = "Activaste la ubicación manual. Da clic dónde te encuentras.";
                    this.setbanderaUbicacionUsuario(true)
                }
            }else{
                this.mylocation()
            }
        },

        faillocation() {
            alert(1)
            if (!("geolocation" in navigator)) {

                this.faillocation1("Geolocation is not available.")

                return;
            }
            // get position
            navigator.geolocation.getCurrentPosition(
                pos => {
                    console.log(pos)
                    this.oklocationQ()
                },
                err => {
                    this.Msgfallo(err)

                }
            );
        },
        ...mapMutations(['setBanks']),
        ...mapMutations(['setdialogFirst']),
        ...mapMutations(['setdialoginfo']),
        ...mapMutations(['setdialogubicacion']),
        ...mapMutations(['setbanderaUbicacionUsuario']),
        

    },

    created() {
        /*  if (this.MiubicacionActual.length === 0) {
              this.faillocation()
          }*/

        
        this.banderaBtnUbicacion = true;
        
        this.setdialogFirst(true);
        if (screen.width < 900){
           this.menu=true;
        }
          
        let uri = window.location.search.substring(1);
        let params = new URLSearchParams(uri);
        
        if (params.get("bdb") === 'true')
            this.cheksbank.push('bdb')
        if (params.get("atm") === 'true')
            this.cheksbank.push('atm')
        if (params.get("mlf") === 'true')
            this.cheksbank.push('mlf')
        if (params.get("atb") === 'true')
            this.cheksbank.push('atb')
        if (params.get("agc") === 'true')
            this.cheksbank.push('agc')
        
        this.banderaUbi = this.$store.state.banderaUbicacionUsuario;
        if(!this.banderaUbi){
            if (this.MiubicacionActual.length == 0) {
                navigator.geolocation.getCurrentPosition(
                        pos => {
                            this.mylocationAllow1(pos)
                        },
                        err => {
                            this.Msgfallo(err)
                        }
                    );
            }else{
                this.drawIni();
            }

        }

        //this.ObtenerDistancias();
        
        this.setdialogFirst(false);
    }
};
</script>


<style>
@font-face {
    font-family: 'BgFont';
    src: url('../assets/fonts/NunitoSans-Regular.ttf') format('truetype');
}

.v-application .deep-purple--text.text--accent-4 {
    color: rgba(0, 0, 0, 0.87) !important;
}

.theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
    color: rgba(0, 0, 0, 0.87) !important;
}

html body {
    width: 100%;
    height: 100% !important;
}

.scroll
{
     overflow-x:hidden;
     overflow-y:hidden;
}

.containermap {
    position: fixed;
    width: 100%;
    height: 300px;
}

.overlayacontrol .v-sheet.v-card {
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
    height: 40px;
    text-align: center;
    padding-top: 5px;

}

.ubicacion .v-sheet.v-card {
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
    height: 400px;
    text-align: center;
    padding-top: 50px;

}

.ovecontrol {
    position: relative;
    width: 100%;
    height: 127px;
    background-color: transparent !important;
}


.overlaya {
    position: absolute;
    left: 20px;
    top: 20px;
    width: 430px !important;
    height: 100px;

}

.overlayacontrol {
    position: absolute;
    left: 20px;
    top: 20px;
    width: 65px;
    height: 150px;
    left: 96%;
    top: 75vh;
    background-color: transparent !important;

}

.ubicacion {
    position: absolute;
    left: 20px;
    width: 800px;
    height: 150px;
    left: 40%;
    top: 35vh;
    background-color: transparent !important;

}
.map-Info-area .v-sheet.v-card:not(.v-sheet--outlined) {
    box-shadow: none !important;
}

.v-autocomplete__content.v-menu__content {
    max-height: 304px;
    width: 430px !important;
    padding-top: 10px !important;
    left: 20px !important;
    transform-origin: left top;
    z-index: 8;
    min-width: 430px !important;
}

.banner-bg {
    padding-left: 8%;
    padding-top: 3% ;
    height: 84px !important;
    background:#bc157c !important;
    border-radius: 8px 8px 0px 0px !important;

}

.banner-bg2 {
    padding-left: 14%;
    padding-top: 6% ;
    height:146px;
    background:#bc157c !important;
}

.bannerbdb-contenedor{
    height:104px;
    background:#012244  !important;
}

.bannerbdb {
    height:104px;
    width: 100%;
    object-fit: fill;
}

.bannernobdb-contenedor{
    padding-left: 45px;
    padding-top: 19px ;
    height:104px;
    background:#bc157c  !important;
}

.bannernobdb {
    height:60px;
    width: 200px;
    object-fit: fill;
}

#tool-buscar .v-sheet.v-toolbar:not(.v-sheet--outlined) {
    box-shadow: none !important;
    border-radius: 0px 0px 8px 8px !important;

    box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.05);
}

#tool-buscar .v-input__icon {
    display: none
}

#tool-buscar .theme--light.v-text-field--solo-inverted.v-input--is-focused>.v-input__control>.v-input__slot input {
    color: #232020;
    font-family: BgFont !important;
}

#tool-buscar label {
    font-family: BgFont !important;

}

.theme--light.v-label {
    font-family: BgFont !important;
    font-style: normal !important;
    font-weight: bold !important;
    font-size: 14px !important;
    line-height: 22px !important;
    color: rgba(1, 34, 68, 0.8) !important;
    display: inline-block !important;
}

.v-application .red--text {
    color: rgba(1, 34, 68, 0.8) !important;
    caret-color: rgba(1, 34, 68, 0.8) !important;
}

#seleccion-ubicacion .v-icon.v-icon:checked {
    align-items: center;
    display: inline-flex;
    font-feature-settings: "liga";
    font-size: 30px;
    justify-content: center;
    letter-spacing: normal;
    line-height: 1;
    position: relative;
    text-indent: 0;
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), visibility 0s;
    vertical-align: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-color: rebeccapurple;
}

#check-servicios .v-icon.v-icon:checked {
    align-items: center;
    display: inline-flex;
    font-feature-settings: "liga";
    font-size: 30px;
    justify-content: center;
    letter-spacing: normal;
    line-height: 1;
    position: relative;
    text-indent: 0;
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), visibility 0s;
    vertical-align: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-color: rebeccapurple;
}

#cerrarDet {
    top: 7px;
    /* box-shadow: none; */
    border: 10px;
    -webkit-box-shadow: -1px 0px 0px 0px rgb(202 202 202 / 75%);
    -moz-box-shadow: -1px 0px 0px 0px rgb(202 202 202 / 75%);
    ;
    box-shadow: -1px 0px 0px 0px rgb(202 202 202 / 75%);
    border-color: #fbfbfb;
    border-radius: 0px;
    left: 5%;
    padding-left: 25%;

}

#check-servicios {

    border-radius: 8px 8px 8px 8px !important;
    box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.05);
}

#seleccion-ubicacion {

    border-radius: 8px 8px 8px 8px !important;
    box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.05);
}

#check-serviciosmovil {
    background: white!important;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1)!important;
    border-radius: 20px !important;
    
}

#check-serviciosmovil .v-sheet.v-card:not(.v-sheet--outlined) {
    box-shadow: none;
    
}

.text-bgu {
    font-family: BgFont;
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 25px;
    display: unset;
    align-items: center;
    cursor: pointer;
    width: 250px;
    height: 68px;
    left: 21px;
    top: 363px;
    padding-left: 5px;
    color: #DD2780;
}

.text-bg3 {
    font-family: BgFont;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 25px;
    display: flex;
    align-items: center;
    cursor: pointer;
    /* position: absolute; */
    width: 250px;
    height: 60px;
    left: 21px;
    /* left: 10px; */
    top: 363px;
    padding-left: 5px;
    color: #DD2780;
}

.text-bg4 {
    font-family: BgFont;
    font-style: normal;
    font-weight: 600;
    font-size: 21px;
    line-height: 25px;
    display: flex;
    align-items: center;
    cursor: pointer;
    /* position: absolute; */
    width: 250px;
    height: 20px;
    left: 21px;
    /* left: 10px; */
    top: 363px;
    color: #012244;
}

.text-bg5 {
    font-family: BgFont;
    font-style: normal;
    font-weight: 700 !important;
    font-size: 16px;
    line-height: 25px;
    display: flex;
    align-items: center;
    cursor: pointer;
    /* position: absolute; */
    width: 250px;
    height: 45px;
    left: 21px;
    /* left: 10px; */
    top: 363px;
    color: #012244;
}

.text-bgf {
    font-family: BgFont;
    font-style: normal;
    font-weight: 700 !important;
    font-size: 16px;
    line-height: 30px;
    display: flex;
    cursor: pointer;
    /* position: absolute; */
    width: 250px;
    height: 38px;
    left: 21px;
    /* left: 10px; */
    top: 363px;
    color: #012244;
}


.v-menu__content {
    background-color: white;
    max-width: 100% !important;
    left: -1px !important;
    min-width: 100% !important;
    box-shadow: none !important;
}

.theme--light.v-footer {
    background-color: #ffffff !important;
    color: rgba(0, 0, 0, 0.87);
}

#menufooter .v-sheet.v-card:not(.v-sheet--outlined) {
    box-shadow: none !important;
    left: 10px;
}

#menufooter .v-input--selection-controls {
    margin-top: 1px;
    padding-bottom: 7px;
}

.axish .move-up {

    transform: translate(0, -170px);
    -webkit-transform: translate(0, -170px);
    -o-transform: translate(0, -170px);
    -moz-transform: translate(0, -170px);

}

.v-list-item .titulo {
    font-family: BgFont;
    font-style: normal;
    font-weight: 600;
    font-size: 21px !important;
    line-height: 25px;
    display: flex;
    align-items: center;
    color: #012244 !important;
}

.v-list-item .tituloMobile {
font-family: BgFont;
font-style: normal;
font-weight: bold;
font-size: 20px;
line-height: 33px;
/* identical to box height */
display: flex;
align-items: center;
justify-content: stretch;
color: #012244;
}

.v-input__icon {

    display: none !important;
}

.v-list--three-line .v-list-item,
.v-list-item--three-line {
    min-height: 65px !important;
}

.tituloDireccion {
    font-family: BgFont;
    font-style: normal;
    font-weight: bold;
    font-size: 18px !important;
    line-height: 25px;
    display: flex;
    align-items: center;
    color: #C3C8CD !important;
}

.enfasis {
    font-family: BgFont;
    font-style: normal;
    font-weight: 900;
    font-size: 18px !important;
    line-height: 25px;
    display: flex;
    align-items: center;
    color: #012244 !important;
}

.enfasisMobile2 {
    font-family: BgFont;
    font-style: normal;
    font-weight: 900;
    font-size: 18px !important;
    line-height: 21px !important;
    display: flex;
    align-items: center;
    color: #012244 !important;
}

.enfasisMobile {
    font-family: BgFont;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 22px;
    display: flex;
    align-items: center;
    color: #333333;
    /* border-bottom-style: solid;
    border-bottom-color: #D0CFD9; */
}

.modalCambioModo{
    position: sticky;
    font-weight: 600;
    line-height: 22px;
    font-family: BgFont;
    font-style: normal;
    font-size: 16px !important;
    display: flex;
    align-items: center !important;
    text-align: center !important;
    color: #FFFFFF !important;
    background-color:  #AC2E79;
    justify-content: center;
}

.v-snack__wrapper.theme--dark {
    background-color:  #AC2E79 !important;
    color: rgba(255, 255, 255, 0.87) !important;
}

.v-sheet.v-snack__wrapper {
    border-radius: 4px !important;
    box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.05) !important;
}

.v-snack__content {
    flex-grow: 1;
    font-size: 0.875rem;
    font-weight: 400;
    letter-spacing: 0.0178571429em;
    line-height: 1.25rem;
    margin-right: auto;
    padding: 14px 16px;
    text-align: initial;
    padding-bottom: 0px !important;
}

.normal {
    font-family: BgFont;
    font-style: normal;
    font-weight: normal;
    font-size: 18px !important;
    line-height: 25px;
    display: flex;
    align-items: center;
    color: #012244 !important;
}

.filtro {
    font-family: BgFont;
    font-style: normal;
    font-weight: bold;
    font-size: 18px !important;
    line-height: 25px;
    display: flex;
    align-items: center;
    color: #012244;
}

.normalMobile {
    font-family: BgFont;
    font-style: normal !important;
    font-weight: normal !important;
    font-size: 18px !important;
    line-height: 25px;
    display: flex;
    align-items: center;
    color: #012244 !important;
}

.subservicio {
    margin-left: -7px;
    color: #012244 !important;
    font-family: BgFont;
    font-style: normal;
    font-weight: normal;
    font-size: 14px !important;
    background-color: #FFFFFF;
}

.servicio {
    font-family: BgFont;
    font-style: normal;
    font-weight: normal;
    font-size: 14px!important;
    align-items: center;
    color: #012244 !important;
}

.horario {
    font-family: BgFont;
    font-style: normal;
    font-weight: normal;
    font-size: 18px !important;
    line-height: 25px;
    display: flex;
    align-items: center;
    color: #012244 !important;
}

.comollegar {
    font-family: BgFont;
    font-style: normal;
    font-weight: 600;
    font-size: 19px !important;
    color: #C81D6F;
}

.v-list-item--three-line {
    min-height: 10px !important;
}

#detalle {
    width: 30% !important;
}

.titleDrawerBluetitlet {
    font-family: BgFont;
    font-style: normal;
    font-weight: bold;
    font-size: 14px !important;
    display: flex;
    align-items: center;
    color: #012244 !important;
}

.titleDrawerBluesmallt {
    font-family: BgFont;
    font-style: normal;
    font-weight: normal;
    font-size: 14px !important;
    display: flex;
    align-items: center;
    color: #012244 !important;
}

.titleDrawergreysmallt {

    font-family: BgFont;
    font-style: normal;
    font-weight: normal;
    font-size: 14px !important;
    display: flex;
    align-items: center;
    color: #C3C8CD !important;
    text-transform: capitalize;
}

#tool-buscar input {

    font-family: BgFont;
    font-style: normal;
    font-size: 14px !important;
    color: #012244 !important;
}

.v-list--three-line .v-list-item .v-list-item__content,
.v-list-item--three-line .v-list-item__content {
    align-self: center !important;
}

v-list--three-line .v-list-item,
.v-list-item--three-line {
    min-height: 65px !important;
}

.v-list-item__content {
    padding: 0px !important;

}

#tool-buscarmov input {
    font-family: BgFont;
    font-style: normal;
    font-size: 14px !important;
    color: #012244 !important;
}

#tool-buscardet input {
    font-family: BgFont;
    font-size: 14px !important;
    font-style: normal;
    color: #012244 !important;
}

#tool-buscardet .v-divider {
    display: none;
}

hr[role='separator'] {
    display: none;
}

#tool-buscardet .v-toolbar__content {

    width: 90%;
    left: 5%;
    border-radius: 10px;
    box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.05);
    border-radius: 10px;

}

#tool-buscardet header {

    box-shadow: none;

}

#tool-buscar .theme--light.v-label,
#tool-buscardet .theme--light.v-label,
#tool-buscar .theme--light.v-label {
    font-family: BgFont;
    font-style: normal !important;
    font-weight: 500 !important;
    font-size: 17px !important;
    line-height: 22px !important;
    color: #b7b7b7 !important;
    display: inline-block !important;
}

#tool-buscarmov label,
#tool-buscardet input,
#tool-buscar input {
    font-family: BgFont;
    font-size: 15px !important;
    font-style: normal;
    color: #012244 !important;
}

.servicio .v-list-item {
    min-height: 1px !important;
}

.servicio .mdi-menu-down::before {
    content: url("../assets/Ico_bg/magabajo.png");
    margin-top: -12px;
}

label[for=input-14] {
    color: #b7b7b7 !important;
    position: absolute;
    top: -7px;
    left: 0;
    font-size: 1rem;
}

.v-list--two-line .v-list-item,
.v-list-item--two-line {
    font-family: BgFont;
    min-height: 15px !important;
}

.v-navigation-drawer {
    min-height: 100vh !important;

}
.v-list .v-list-item--active { background-color:  #F3F3F5 !important; }
@media (max-width: 900px) {
    /* Leon1989 */

    .v-list-item__action, .v-list-item__avatar, .v-list-item__icon {
        display: contents !important;
    } 

    .vermas {
        font-family: BgFont;
        font-style: normal;
        font-weight: bold;
        font-size: 18px;
        line-height: 50px;
        align-items: center;
        color:#bc157c !important;
    }

    .servicioMobile {
        font-family: BgFont;
        font-style: normal;
        font-weight: normal;
        font-size: 18px!important;
        align-items: center;
        color: #012244 !important;
        height: 61px !important;
        padding-left: 8px !important;

    }

    .subservicioMobile {
    margin-left: -7px;
    color: #012244 !important;
    font-family: BgFont;
    font-style: normal;
    font-weight: normal;
    font-size: 14px !important;
    background-color: #FFFFFF;  
    }

    .v-list-group.v-list-group--active.v-list-group--sub-group.primary--text{
            color: #F3F3F5 !important;
            caret-color: #F3F3F5 !important;
            opacity: 1 !important;
    }

    .v-list-group__items{
            color: #F3F3F5 !important;
            caret-color: #F3F3F5 !important;
            background-color: currentColor;
            padding-bottom: 15px;
    }

    .v-list-group__items:before {
        background-color: currentColor;
        bottom: 0;
        content: "";
        left: 0;
        opacity: 0;
        pointer-events: none;
        position: absolute;
        right: 0;
        top: 0;
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    }

    .comollegarMobile{
        font-family: BgFont;
        font-style: normal;
        font-weight: 600;
        font-size: 18px !important;
        color: #012244;
    }
    
    .v-list .v-list-item--active {
        background-color: transparent !important;
    }

    .theme--light.v-list-item--active:hover::before, .theme--light.v-list-item--active::before {
        opacity: 0 !important;
    }

    .banner-bg {
        padding: 10px 25px 21px 25px !important;
        height: 60px !important;
        background:#bc157c !important;
        border-radius: 0px 0px 0px 0px !important;
    } 
    #tool-buscarmov label,
    #tool-buscardet input,
    #tool-buscar input {
        font-family: BgFont;
        font-size: 18px;
        font-style: normal;
        font-weight: normal;
        line-height: 25px;
        letter-spacing: 0em;
        text-align: left;
        color: #012244 10% !important;
    }
    #tool-buscarmov input {
        font-family: BgFont;
        font-style: normal;
        font-size: 14px !important;
        color: #012244 !important;
    } 
    .v-input__slot{
        padding: 0px !important;
    }
    .v-toolbar__content, .v-toolbar__extension {
        padding: 0px 0px !important;
    }
    .overlaya {
        display: none !important;

    }
    .overlayacontrol {
        left: 84%;
        top: 80%;
    }
    .vl-map {
        height: 80vh !important;
        min-height: 100% !important;
    }
    .v-application--wrap {
        min-height: 85vh !important;
        display: block !important;
    }
    #zomin {
        display: none !important;
    }
    #ubicacionUsuario {
        display: none !important;
    }
    #zomou {
        display: none !important;
    }
    .v-autocomplete__content.v-menu__content {
        background-color: white;
        max-width: 100% !important;
        left: -1px !important;
        min-width: 100% !important;
    }

    .v-menu__content.theme--light.menuable__content__active {
        border-radius: 20px 20px 0px 0px !important;
    }

    .v-menu__content.theme--light.menuable__content__active.v-autocomplete__content {
        border-radius: 0px 0px 0px 0px !important;
    }
}

@media (max-width: 370px) {

    .overlaya {
        display: none !important;

    }

    .overlayacontrol {

        left: 80%;
        top: 40vh;
    }

    .vl-map {

        height: 70vh !important;
        min-height: 100% !important;

    }

    .v-application--wrap {
        min-height: 75vh !important;
    display: block !important;
    }

    #zomin {

        display: none !important;
    }

    #zomou {
        display: none !important;
    }

    #detalle {
        width: 90% !important;
    }
}

@media (min-width: 900px) {
    .movil-toolbar {

        display: none !important;

    }

    .v-footer {
        display: none !important;
    }

}

@media (max-height: 750px) {
.overlayacontrol {
        left: 84%;
        top: 60%;
    }
}

@media (max-height: 650px) {
.v-menu__content.theme--light.menuable__content__active.v-autocomplete__content{
    max-height: 210px !important;
    top: 133px;
    left: 0px;
    transform-origin: left top;
    z-index: 202;
}
.overlayacontrol {
        left: 84%;
        top: 30%;
    }
}

@media (max-height: 550px) {
.v-menu__content.theme--light.menuable__content__active.v-autocomplete__content{
    max-height: 110px !important;
    top: 133px;
    left: 0px;
    transform-origin: left top;
    z-index: 202;
}
.overlayacontrol {
        left: 84%;
        top: 20%;
    }
}

@media (max-height: 450px) {
.v-menu__content.theme--light.menuable__content__active.v-autocomplete__content{
    max-height: 70px !important;
    top: 133px;
    left: 0px;
    transform-origin: left top;
    z-index: 202;
}
.overlayacontrol {
        left: 84%;
        top: 0%;
    }

}
</style>